import { units } from '@m/alchemy-theme';
import styled from 'styled-components';

const DEFAULT_COLUMN_WIDTH = '200px';

export const semanticBreakpoints = {
  mobile: '768px',
  tablet: '992px',
  desktop: '1200px',
  largeDesktop: '1600px',
};

export const EqualColumnsGrid = styled.div<{ columnMinWidth?: string; gap?: string }>`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(${({ columnMinWidth }) => columnMinWidth || DEFAULT_COLUMN_WIDTH}, 1fr)
  );
  gap: ${({ gap }) => gap || units(3.5)};
  align-items: stretch;
`;

export const GridContainer = styled.div<{
  columns: number;
  breakpoint?: keyof typeof semanticBreakpoints;
  gap?: string;
  columnMinWidth?: string;
}>`
  display: grid;
  grid-template-columns: ${({ columns, columnMinWidth }) =>
    `repeat(${columns}, minmax(${columnMinWidth || DEFAULT_COLUMN_WIDTH}, 1fr))`};
  gap: ${({ gap }) => gap || units(3.5)};

  @media (max-width: ${({ breakpoint }) => semanticBreakpoints[breakpoint || 'mobile']}) {
    grid-template-columns: 1fr;
  }
`;

// When using Graph components inside a grid, the GraphContainer
// should have a min-width of 100% to resize properly
export const GraphContainer = styled.div`
  min-width: 100%;
`;
